export default {"src":"/_next/static/media/getting-started-beach.mono.f02421bd.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};